import React from 'react';
import graphql from 'graphql';
import Link from "gatsby-link";
import Helmet from 'react-helmet';
import Content, { HTMLContent } from '../components/Content';
import Team from '../components/Team';
import ResourceList from '../components/ResourceList';
import Contact from '../components/Contact';
import NewsArticlesSection from '../components/NewsArticlesSection'

export const AerospaceNewsPageTemplate = ({ title, content, newsArticles, contentComponent }) => {
  const PageContent = contentComponent || Content;

  return (
    <div>
      <Helmet
        title={ "San Juan Software | " + title }
      />
      <NewsArticlesSection newsArticles={newsArticles} />
      <section className="section content is-sjs-dark-blue">
          <div className="container">
              <div className="columns is-v-centered">
                  <div className="column">
                      <span className="header-font is-size-3">More News:</span>
                  </div>
                  <div className="column">
                      <Link className="button is-medium is-sjs-yellow" to="/news">News Home</Link>
                  </div>
                  <div className="column">
                      <Link className="button is-medium is-sjs-yellow" to="/sjs-news">SJS News</Link>
                  </div>
                  <div className="column">
                      <Link className="button is-medium is-sjs-yellow" to="/iot-news">IoT News</Link>
                  </div>
              </div>
          </div>
      </section>
      <Contact />
    </div>
  );
};

export default ({ data }) => {
  const { frontmatter, html } = data.markdownRemark;
  const newsArticles = data.allMarkdownRemark.edges;
  
  return (<AerospaceNewsPageTemplate
    contentComponent={HTMLContent}
    title={frontmatter.title}
    content={html}
    newsArticles={newsArticles}
  />);
};

export const PageQuery = graphql`
  query aerospaceNewsPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
        html
        frontmatter {
            path
            tag
            title
        }
    }
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { fileAbsolutePath: {regex : "/src/pages/news/_/"}, frontmatter: { tags: { in: ["Aerospace News"] } } })
      {
      edges {
        node {
          html
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            tags
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/aerospace-news-page.js